import { Controller } from '@hotwired/stimulus'

export default class NativeBridgeMessageSenderController extends Controller {
  static values = { message: String, event: String }

  connect = () => {
    if (!this.hasEventValue) return

    document.addEventListener(this.eventValue, this.send)
  }

  disconnect = () => {
    if (!this.hasEventValue) return

    document.removeEventListener(this.eventValue, this.send)
  }

  send = (e) => {
    e.preventDefault()

    window.TurboNativeBridge.postMessage(this.messageValue)
  }
}
